/* eslint-disable no-param-reassign */
export default {
  constantGravity(m,g,vector) {
    vector.x = 0;
    vector.y = m * g;
  },
  gravity(G, m1,m2,vector) {
    vector.multiply(-G * m1 * m2 / (vector.lengthSquared() * vector.getLength()));
  },
  linearDrag(k, vel, vector) {
    const velMag = vel.getLength();
    if (velMag > 0) {
      vector.multiply(-k);
    }
    else {
      vector.reset(0,0);
    }
  },
  add(arr, vector) {
    vector.reset(0,0);
    for (let i = 0; i < arr.length; i++) {
      const force = arr[i];
      vector.incrementBy(force.x, force.y);
    }
  }
};